function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-elecRadiateur");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-elecRadiateur"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(3.000000, 3.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})), /*#__PURE__*/React.createElement("path", {
  d: "M27,3 L27,27 L3,27 L3,3 L27,3 Z M11.0623475,9.6095656 C10.8467166,9.43706082 10.5320704,9.47202151 10.3595656,9.68765248 C8.8801448,11.5369285 8.8801448,13.4630715 10.3595656,15.3123475 L10.3595656,15.3123475 L10.4963363,15.4900753 C11.5449119,16.9091031 11.4993216,18.2629574 10.3595656,19.6876525 C10.1870608,19.9032834 10.2220215,20.2179296 10.4376525,20.3904344 C10.6532834,20.5629392 10.9679296,20.5279785 11.1404344,20.3123475 C12.6198552,18.4630715 12.6198552,16.5369285 11.1404344,14.6876525 L11.1404344,14.6876525 L11.0036637,14.5099247 C9.95508813,13.0908969 10.0006784,11.7370426 11.1404344,10.3123475 C11.3129392,10.0967166 11.2779785,9.78207037 11.0623475,9.6095656 Z M15.0623475,9.6095656 C14.8467166,9.43706082 14.5320704,9.47202151 14.3595656,9.68765248 C12.8801448,11.5369285 12.8801448,13.4630715 14.3595656,15.3123475 L14.3595656,15.3123475 L14.4963363,15.4900753 C15.5449119,16.9091031 15.4993216,18.2629574 14.3595656,19.6876525 C14.1870608,19.9032834 14.2220215,20.2179296 14.4376525,20.3904344 C14.6532834,20.5629392 14.9679296,20.5279785 15.1404344,20.3123475 C16.6198552,18.4630715 16.6198552,16.5369285 15.1404344,14.6876525 L15.1404344,14.6876525 L15.0036637,14.5099247 C13.9550881,13.0908969 14.0006784,11.7370426 15.1404344,10.3123475 C15.3129392,10.0967166 15.2779785,9.78207037 15.0623475,9.6095656 Z M19.0623475,9.6095656 C18.8467166,9.43706082 18.5320704,9.47202151 18.3595656,9.68765248 C16.8801448,11.5369285 16.8801448,13.4630715 18.3595656,15.3123475 L18.3595656,15.3123475 L18.4963363,15.4900753 C19.5449119,16.9091031 19.4993216,18.2629574 18.3595656,19.6876525 C18.1870608,19.9032834 18.2220215,20.2179296 18.4376525,20.3904344 C18.6532834,20.5629392 18.9679296,20.5279785 19.1404344,20.3123475 C20.6198552,18.4630715 20.6198552,16.5369285 19.1404344,14.6876525 L19.1404344,14.6876525 L19.0036637,14.5099247 C17.9550881,13.0908969 18.0006784,11.7370426 19.1404344,10.3123475 C19.3129392,10.0967166 19.2779785,9.78207037 19.0623475,9.6095656 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ElecRadiateur = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ElecRadiateur, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-elecRadiateur.93b28d8c.svg";
export { ForwardRef as ReactComponent };